import CoverModelCommon from 'common/models/cover';

export default class CoverModel extends CoverModelCommon {}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    cover: CoverModel;
  }
}
